import { useQuery } from '@tanstack/react-query'
import { getAssignmentDetail } from 'api/assignment/getAssignmentDetail'
import { assignmentKeys } from './keys'

export const useAssignmentDetailQuery = (
  request: NonNullable<Parameters<typeof getAssignmentDetail>[0]>
) => {
  return useQuery({
    queryKey: assignmentKeys.detail.byId(request.assignmentId),
    queryFn: () => getAssignmentDetail(request),
    enabled: !!request.assignmentId,
  })
}
